import { BaseRepository } from "repositories/BaseRepository";

export class AgentsRepository extends BaseRepository {
  constructor(db) {
    super(db, "agents");
  }

  async getByLineId(lineId, repositories) {
    const relations = await repositories.agentLines.where("lineId").eq(lineId);
    const ids = relations.map(r => r.agentId);
    return await Promise.all(ids.map(id => this.getById(id)));
  }
}
